import React, { useState, useEffect, useRef } from 'react';
import { MarkGithubIcon, XIcon } from '@primer/octicons-react';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" ref={sectionRef} className={`max-w-4xl mx-auto my-12 sm:my-16 px-4 sm:px-6 opacity-0 translate-y-8 transition-all duration-700 w-full ${isVisible ? 'opacity-100 translate-y-0' : ''}`}>
      <div className="text-center mb-8 sm:mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-2">Contact</h1>
        <div className="w-16 h-1 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
      </div>
      <p className="text-center text-lg text-gray-600 mb-8">お気軽にお問い合わせください</p>

      <div className="bg-white/5 backdrop-blur-sm rounded-2xl shadow-xl p-6 sm:p-8">
        <div className="mb-8">
          <div className="flex items-center gap-4 p-4 bg-primary/5 rounded-xl hover:bg-primary/10 transition-colors duration-300 hover:translate-x-2">
            <span className="text-2xl">📧</span>
            <a href="mailto:sample@mail" className="text-gray-800 font-medium hover:text-primary transition-colors duration-300">
              sample@mail
            </a>
          </div>
        </div>

        <div className="text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-6">Connect with me</h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://github.com/yabu1121"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-6 py-3 bg-gray-800 text-white rounded-xl font-semibold transition-all duration-300 hover:bg-gray-900 hover:-translate-y-2 hover:shadow-lg"
            >
              <MarkGithubIcon size={24} />
              <span>GitHub</span>
            </a>
            <a
              href="https://x.com/papox_57"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-6 py-3 bg-blue-500 text-white rounded-xl font-semibold transition-all duration-300 hover:bg-blue-600 hover:-translate-y-2 hover:shadow-lg"
            >
              <XIcon size={24} />
              <span>X (Twitter)</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
